import isScreenshareTrack from '../../lib/isScreenshareTrack'
import audit from '../../lib/audit'
import { Logger } from 'twilio-video'
import { qualityWarningActions } from '../../dataStore/slices/qualityWarning'
import { Level } from '../../dataStore/slices/qualityWarning/qualityWarningSlice'
import getDateDiff from '@bt-react/libs/getDateDiff'

const twilioLogger = Logger.getLogger('twilio-video')

const LOCAL_STORAGE_LOGS_KEY = 'talks-present-logs'

export const setErrorLogger = () => async (dispatch, getState) => {
  twilioLogger.methodFactory = function (methodName, logLevel, loggerName) {
    return function (datetime, logLevel, component, message, data) {
        if (((data && data.name === 'stats-report') || logLevel === 'error' || logLevel === 'warning') ) {

          const localStorageLogsString = localStorage.getItem(LOCAL_STORAGE_LOGS_KEY)

          const localStorageLogs = localStorageLogsString ? JSON.parse(localStorageLogsString) : []

          const { room, config, user, syncSeatingOrder, qualityWarning, webcast, tracks, syncUi, playIn } = getState()
          const output = {
            roomId: room.room.sid,
            date: datetime,
            gigId: config.roomname,
            BTID: user && user.BTID ? `${user.BTID}-${config.role}` : false,
            name: user && user.data && user.data.firstName ? `${user.data.firstName} ${user.data.lastName}` : false,
            platform: navigator.userAgent.split('(')[1].split(')')[0],
            browser: navigator && navigator.userAgentData ? `${navigator.userAgentData.brands[1].brand} - ${navigator.userAgentData.brands[1].version}` : false,
            cpuCores: navigator ? navigator.hardwareConcurrency : false,
            deviceMemory: navigator ? navigator.deviceMemory : false,
            position: user && user.BTID ? Object.keys(syncSeatingOrder.seatingOrder).findIndex((val) => val === user.BTID) + 1 : false,
            bridgeName: config.bridgeName || false,
            localVideoTracks: [],
            localAudioTracks: [],
            localStore: {
              roomParticipants: room.room.participants,
              localParticipant: Array.from(room.room.localParticipant.tracks.keys()),
              tracks: tracks,
              syncUi: syncUi,
              playIn: playIn
            }
          }

          output.networkQuality = room.room.localParticipant.networkQualityLevel
          output.state = room.room.localParticipant.state
          output.signalingRegion = room.room.localParticipant.signalingRegion
          output.mediaRegion = room.room.mediaRegion

          if (room.room && room.room.localParticipant.videoTracks) {
            room.room.localParticipant.videoTracks.forEach((publication) => {
              const trackInfo = {
                name: publication.track.name,
                dimensions: publication.track.dimensions,
                id: publication.track.mediaStreamTrack.id,
                label: publication.track.mediaStreamTrack.label,
                kind: publication.track.mediaStreamTrack.kind,
                processor: !!publication.track.processor,
                trackSid: publication.trackSid,
                isTrackEnabled: publication.isTrackEnabled
              }
        
            output.localVideoTracks.push(trackInfo)
            })
          }

          if (room.room && room.room.localParticipant.audioTracks) {
            room.room.localParticipant.audioTracks.forEach((publication) => {
              const trackInfo = {
                name: publication.track.name,
                dimensions: publication.track.dimensions,
                id: publication.track.mediaStreamTrack.id,
                label: publication.track.mediaStreamTrack.label,
                kind: publication.track.mediaStreamTrack.kind,
                processor: !!publication.track.processor,
                trackSid: publication.trackSid,
                isTrackEnabled: publication.isTrackEnabled
              }
        
            output.localAudioTracks.push(trackInfo)
            })
          }

          if (data.name === 'stats-report') {

            const maxDataCollectionLoops = 6
            const targetScore = 10
            let screenShareTrackId = null
            let disabledTrackId = null
            let processor = null
            for (const [, tracks] of room.room.localParticipant.videoTracks) {

              if (isScreenshareTrack(tracks)) screenShareTrackId = tracks.trackSid

              if (!tracks.isTrackEnabled) disabledTrackId = tracks.trackSid

              if (tracks.track.processor) processor = true
            }

            output.hidden = document.hidden

            data.payload.localVideoTrackStats.forEach((layer) => {

              if (!document.hidden &&  layer.frameRate > 1 && layer.trackSid !== screenShareTrackId && layer.trackSid !== disabledTrackId && layer.roundTripTime > 0 && qualityWarning.closed) {
                layer.networkQuality = room.room.localParticipant.networkQualityLevel
                dispatch(qualityWarningActions.setStats(layer))
                
              }

            })

            if (qualityWarning.stats.length >= maxDataCollectionLoops) {
              let frameRateTotal = null
              let avgEncodeDelayTotal = null
              let avgPacketSendDelayTotal = null
              let roundTripTimeTotal = null
              let networkQuality = null

              let score = 0
              let avgNetworkQuality = 0
              
              qualityWarning.stats.forEach((entry) => {
                frameRateTotal += entry.frameRate
                avgEncodeDelayTotal += entry.avgEncodeDelay
                avgPacketSendDelayTotal += entry.avgPacketSendDelay
                roundTripTimeTotal += entry.roundTripTime
                networkQuality += entry.networkQuality
              })

              score = frameRateTotal/qualityWarning.stats.length - ((avgEncodeDelayTotal/qualityWarning.stats.length)*0.05 + (avgPacketSendDelayTotal/qualityWarning.stats.length)*0.05 + (roundTripTimeTotal/qualityWarning.stats.length)*0.02)
              avgNetworkQuality = networkQuality/qualityWarning.stats.length
              output.performanceScore = score
              if (avgNetworkQuality < 2.5 || score < targetScore) {

                let warningType = null
                if (qualityWarning.level === null && !processor) {
                  warningType = Level.TABS_WARNING
                } else if ((qualityWarning.level === null || qualityWarning.level < Level.BACKGROUND_WARNING) && processor) {
                  warningType = Level.BACKGROUND_WARNING
                } else if (qualityWarning.level < Level.CAMERA_WARNING) {
                 warningType = Level.CAMERA_WARNING
                }


                if (warningType && disabledTrackId === null) {
                  const dateDiff = getDateDiff(webcast.collection[[`${config.channelId}${config.webcastId}`]].data.start)
                  const minutesToLive = dateDiff.duration.days * 24 * 60 + dateDiff.duration.hours * 60 + dateDiff.duration.minutes + dateDiff.duration.seconds / 60
                  if (!dateDiff.hasPassed && minutesToLive >= 2) {
                    dispatch(qualityWarningActions.activate(warningType))
                    audit.addEntry('PresenterService', 'WarningDisplay', JSON.stringify({userId: user.BTID, warningType: warningType}), undefined, undefined, false)
                  }
                }
                
              }

              dispatch(qualityWarningActions.clearStats())
               
            }

            output.data = data
            output.type = 'report'
          } else {
            output.data = {datetime, logLevel, component, message, data}
            output.type = 'error'
          }
          
          //Its getting to big. Stop adding more
          if (localStorageLogsString && localStorageLogsString.length + JSON.stringify(output).length >= 1000*50) return

          localStorageLogs.push(output)
          localStorage.setItem(LOCAL_STORAGE_LOGS_KEY, JSON.stringify(localStorageLogs))
        }
        
    }
  }

  twilioLogger.setLevel('debug')
}

export const gatherLogs = () => async (dispatch, getState) => {

  const localStorageLogsString = localStorage.getItem(LOCAL_STORAGE_LOGS_KEY)
  if (localStorageLogsString) {
    try {
      await audit.addEntry('PresenterService', 'PresenterReport', localStorageLogsString, 'report', undefined, false)
    } catch (e) {
      return
    }
    localStorage.setItem(LOCAL_STORAGE_LOGS_KEY, JSON.stringify([]))
  }

}
